export default {
  label: "No encontrado",
  noPageFound: {
    title: "No Encontrado (404)",
    text: "La página que estabas buscando no existe. Puede que hayas escrito mal la dirección o que la página se haya movido.",
  },
  restrictedLink: {
    title: "Este enlace está restringido.",
    text: "Para más información, por favor contacta a tu administrador del sistema.",
  },
  goBackLink: "Volver a la página de inicio.",
};
